import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { UserGroupPermissionsComponent } from './user-group-permissions.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { PermissionSelectorModule } from 'src/app/shared/components/permission-selector/permission-selector.module';

@NgModule({
  declarations: [
    UserGroupPermissionsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule,
    FlexLayoutModule,
    DialogContainerModule,
    PermissionSelectorModule,
  ],
  exports: [
    UserGroupPermissionsComponent
  ]
})
export class UserGroupPermissionsModule { }
